import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todos os MaterialGeneticos cadastradas no banco de dados
 */
const getAllMaterialGeneticos = async () => {
	return registryApi.get('v1/MaterialGenetico')
}

/**
 * Retorna Materiais geneticos para o formato do componente DropdownFk
 */
const getDropdownMateriaisGeneticos = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/MaterialGenetico')

	return result.map((materialGenetico) => {
		return {
			id: materialGenetico.id,
			[i18n.t('code')]: `EF-${materialGenetico.mtge_cd_codigo}`,
			[i18n.t('description')]: materialGenetico.mtge_ds_descricao,
			[i18n.t('name')]: materialGenetico.mtge_cd_codigo,
			[i18n.t('species')]: materialGenetico.especie,
		}
	})
}

/**
 * Cadastrar nova MaterialGeneticos no banco de dados
 * @param {Object} body MaterialGenetico que será cadastrada
 */
const createMaterialGenetico = async (body) => {
	return registryApi.post('v1/MaterialGenetico', body)
}

/**
 * Atualiza MaterialGenetico no banco de dados
 * @param {Object} body MaterialGenetico que será atualizada
 */
const updateMaterialGenetico = async (body) => {
	return registryApi.put('v1/MaterialGenetico', body)
}

/**
 * Lista dos ids de MaterialGenetico que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de MaterialGenetico
 */
const deleteMaterialGeneticoByIdList = async (data) => {
	return registryApi.delete('v1/MaterialGenetico/DeleteByIdList', { data })
}

export {
	getAllMaterialGeneticos,
	getDropdownMateriaisGeneticos,
	createMaterialGenetico,
	updateMaterialGenetico,
	deleteMaterialGeneticoByIdList,
}
